import * as React from "react";
import {Map} from "immutable";
import {
  Editor,
  EditorState,
  RichUtils,
  DefaultDraftBlockRenderMap,
  convertFromRaw,
  convertToRaw
} from "draft-js";
// 检查是否为Url字符串
import { checkUrl } from "utils/tool";
import addCComponent from "./addCComponent";
import blockRender from "./blockRender";

interface ISimpleEditorProps {
  // 设置编辑器焦点
  setFocus?: any;
  // 设置 | 返回SimpleEditor this
  setRef?: any;
}

// 简单编辑器
class SimpleEditor extends React.Component<ISimpleEditorProps, any> {
  editorRef = null;
  state = {
    // 编辑器状态管理对象
    editorState: null
  };
  constructor(props: ISimpleEditorProps) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty()
    };

    const { setFocus, setRef } = this.props;

    setFocus && setFocus(this.focus);
    setRef && setRef(this);
  }

  // 判断编辑器内容是否为空
  static isEmpty(editorRaw) {
    for (const item of editorRaw.blocks) {
      if (item.type === "unstyled") {
        if (item.text && item.text.trim()) {
          return false;
        }
      } else if (item.type === "atomic") {
        return false;
      }
    }
    return true;
  }

  // 重置编辑器
  reset = () => {
    this.setState({
      editorState: EditorState.createEmpty()
    });
  };

  // 给编辑器聚焦
  focus = () => {
    const editorRef: any = this.editorRef;
    if (editorRef != null) editorRef.focus();
  };

  // 获取去编辑器Ref对象
  getEditorRef = ref => {
    this.editorRef = ref;
  };

  // 判断在unstyled块下内容是否为Url字符串
  estimateUrl = data => {
    if (data.type === "unstyled" && data.text)
      return checkUrl(data.text.trim());
    else return false;
  };

  // 添加链接 oldData:{blocks:[],entityMap:[]} transformUrl:block 待转换为链接的对象
  addUrl = (oldData, transformUrl) => {
    let contentState = null;
    let editorState = null;
    if (oldData.blocks.length != 0) {
      // 转换Raw 数据
      contentState = convertFromRaw(oldData);
      // 转换ContentState对象为EditorState对象
      editorState = EditorState.createWithContent(contentState);
    } else {
      // 创建空的EditorState 对象
      editorState = EditorState.createEmpty();
    }
    // 把编辑器内的光标移动到末尾
    editorState = EditorState.moveFocusToEnd(editorState);
    // 添加url自定义组件
    return addCComponent(editorState, "url", {
      title: "",
      src: transformUrl.text
    });
  };

  // 添加实体  图片，文档
  addEntity = (url, type, name) => {
    return this.setState({
      editorState: addCComponent(this.state.editorState, type, {
        title: name,
        src: url
      })
    });
  };

  // 获取Editor 原始数据
  getEditorStateRaw = () => {
    const state: any = this.state.editorState;
    if (state != null) {
      try {
        return convertToRaw(state.getCurrentContent());
      } catch (error) {
        console.warn(error);
        return null;
      }
    } else {
      return null;
    }
  };

  // 编辑器数据更新事件
  onChange = editorState => {
    // 转换为数据对象 {blocks:[],entityMap:[]}
    console.log("onChange222", "splice1");
    const editorData = convertToRaw(editorState.getCurrentContent()),
      // 块数据
      blocks = editorData.blocks,
      // blocks长度
      len = blocks.length,
      // 最后一个block的索引
      lastIndex = (blocks.length > 1 && len - 1) || 0,
      // 最后一个块对象
      lastBlock = blocks[lastIndex],
      // 判断最后一个块数据是否为链接
      res = this.estimateUrl(lastBlock);
    // lastBlock为链接字符串时转换为自定义A | link组件
    console.log("onChange222", "splice2");
    if (res) {
      console.log("onChange", "splice");
      blocks.splice(lastIndex, 1);
      return this.setState({ editorState: this.addUrl(editorData, lastBlock) });
    } else {
      console.log("onChange", editorData);
      return this.setState({ editorState });
    }
  };

  blockRenderMap = Map({
    a: {
      element: "LINK"
    },
    atomic: {
      element: "div"
    },
    unstyled: {
      element: "span"
    }
  });

  // Include 'paragraph' as a valid block and updated the unstyled element but
  // keep support for other draft default block types
  extendedBlockRenderMap = DefaultDraftBlockRenderMap.merge(
    this.blockRenderMap
  );

  handleKeyCommand = (command, editorState) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return "handled";
    }
    return "not-handled";
  };

  render() {
    return (
      <Editor
        ref={this.getEditorRef}
        editorState={this.state.editorState}
        onChange={this.onChange}
        handleKeyCommand={this.handleKeyCommand}
        blockRendererFn={blockRender}
        blockRenderMap={this.extendedBlockRenderMap}
      />
    );
  }
}

export default SimpleEditor;
